module.exports = __webpack_public_path__ + "img/xr2_detail_1.bd3af4f5.jpg";